// ✅ Match backend enum exactly - Your API returns numeric values
export const OFFER_STATUS = {
  DRAFT: 0,      // Draft
  SENT: 1,       // Sent
  ACCEPTED: 2,   // Accepted
  CONVERTED: 3,  // Converted to Invoice
  REJECTED: 4,   // Rejected
};

export const OFFER_STATUS_LABELS = {
  0: 'Draft',
  1: 'Sent',
  2: 'Accepted',
  3: 'Converted',
  4: 'Rejected',
};

export const getStatusColor = (status) => {
  const colors = {
    0: '#9e9e9e',  // Draft - Grey
    1: '#2196f3',  // Sent - Blue
    2: '#4caf50',  // Accepted - Green
    3: '#673ab7',  // Converted - Purple
    4: '#f44336',  // Rejected - Red
  };
  return colors[status] || '#ffc107';
};

export const getStatusLabel = (status) => {
  return OFFER_STATUS_LABELS[status] || 'Unknown';
};

// ✅ Business rules
export const canEditOffer = (status) => {
  // Can edit if Draft or Sent
  return status === OFFER_STATUS.DRAFT || status === OFFER_STATUS.SENT;
};

export const canDeleteOffer = (status) => {
  // Can delete if not converted
  return status !== OFFER_STATUS.CONVERTED;
};

export const canConvertOffer = (status) => {
  // Can only convert if Accepted
  return status === OFFER_STATUS.ACCEPTED;
};

export const canChangeStatus = (status) => {
  // Can change status if not converted
  return status !== OFFER_STATUS.CONVERTED;
};